import {StylesConfig} from "react-select";
import {SITE_FONT_STACK} from "../../utils/styles/fontStack";

// custom styling of the select category dropdown list for the OrderBy component
// Shared by AmountToggle, the /admin/leads status filter (Table.tsx) and every FilterPanel select.
export const customAmountToggleSelectStyles: StylesConfig<any, false> = {
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#333333' : '#ffffff',
        color: state.isSelected ? '#ffffff' : '#000000',
        whiteSpace: 'nowrap',
        fontSize: '0.87rem',
        lineHeight: '1.31rem',
        height: 29,
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
    }),
    control: (provided, state) => ({
        ...provided,
        width: 'fit-content',
        height: 41,
        background: '#ffffff',
        borderRadius: 25,
        border: 'none',
        boxShadow: 'none',
        cursor: 'pointer',
        "&:hover": {
            outline: 'none',
            boxShadow: 'none'
        },
        "&:active": {
            outline: 'none',
            boxShadow: 'none'
        },
        "&:focus": {
            outline: 'none',
            boxShadow: 'none'
        }
    }),
    indicatorSeparator: () => ({}),
    valueContainer: (provided) => ({
        ...provided,
        padding: 0,
        paddingInlineStart: 20,
        // Was a bare 'Poppins', which has no Hebrew glyphs — Hebrew fell through to the browser's
        // default serif. See SITE_FONT_STACK.
        fontFamily: SITE_FONT_STACK,
        fontSize: '.87rem',
        lineHeight: '1.31rem',
        overflow: 'none',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#34A7F0',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        padding: 8,
        paddingInlineEnd: 13,
    }),
    menu: (provided) => ({
        ...provided,
        width: 'fit-content',
        boxShadow: '0px 4px 9px rgba(116, 116, 116, 0.25)',
        borderRadius: 5,
    }),
};